export const NotFound = () => {
    return (
        <div className="not-found">Nie znaleziono zasobu pod tym adresem...</div>
    );
};